import Vue from 'vue';
import './plugins/vuetify'
import './plugins/vuetify'
import App from './App.vue';
import router from './router';
import store from './store';
import moment from 'moment'
import axios from 'axios';
import eventBus from './components/eventBus.js';
import TreeView from "vue-json-tree-view"
Vue.use(TreeView)
Vue.config.productionTip = false;

Vue.prototype.$http = axios;
Vue.prototype.$moment = moment;
Vue.prototype.$bus= eventBus;
Vue.prototype.$store= store;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
